<template>
	<div class="page-accounting-action" v-if="verifySubsidiary">
		<header-page
			actions
			name="page-batch-accounting"
			:title="$route.meta.title"
			@run-action="runAction"
			:button-close="openMobile"
			tabindex="-1"
			@click-close="closeMobile"
		/>
		<action-bar
				:value-disabled="valuesDisabled"
				class="action-mobile"
				:resource-uri="$route.name"
				@run-action="runAction"
		></action-bar>
		<v-dialog
			content-class="dialog-loading"
			max-width="300"
			persistent
			v-model="dialogLoading"
		>
			<label class="loading-search">
				Espere unos segundos por favor
			</label>
			<v-progress-linear
				indeterminate
				color="white"
				class="mb-0"
			></v-progress-linear>
		</v-dialog>
		<div class="pt-3 px-4 show-mobile">
			<v-layout row align-center wrap>
				<v-flex xs4 md2 pl-2 lg2>
					<BaseSelect
						class="select-accouting"
						label="Módulos"
						item-text="name"
						item-value="code"
						:height="32"
						v-model="model.moduleId"
						:items="modulesFilter"
						:value="model.moduleId"
						@input="setModule"
					/>
				</v-flex>
				<v-flex xs4 md2 pl-2 lg2>
					<BaseSelect
						:disabled="!model.moduleId"
						class="select-accouting"
						label="Estado de registros"
						item-text="name"
						item-value="id"
						:height="32"
						v-model="model.accountingSeat"
						:items="statusRecords"
						:value="model.accountingSeat"
						@input="setStatusRecords"
					/>
				</v-flex>
				<v-flex xs4 md2 pl-2 lg2>
					<BaseSelect
						class="select-accouting"
						item-text="name"
						item-value="id"
						label="Fechas"
						:height="32"
						:items="typesDate"
						@input="getDataDate($event)"
					/>
				</v-flex>
				<v-flex xs4 md2 pl-2 lg2 v-if="flagDate">
					<span class="captionDate">Fecha Desde</span>
					<date-component
						round
						:date="model.startDate"
						icon="/static/img/calendar.svg"
						@on-input="getDate({ model: 'startDate', value: $event })"
					></date-component>
				</v-flex>
				<v-flex xs4 md2 pl-2 lg2 v-if="flagDate">
					<span class="captionDate">Fecha hasta</span>
					<date-component
						round
						:date="model.endDate"
						icon="/static/img/calendar.svg"
						@on-input="getDate({ model: 'endDate', value: $event })"
					></date-component>
				</v-flex>
				<v-flex xs3 sm9 lg2 xs12>
					<v-layout row>
						<v-flex ml-3>
							<v-btn
								:disabled="!model.moduleId || flagStateRecord || loading"
								color="blue"
								class="ma-0 btn-accounting mt-3"
								@click="loadCont"
							>
								Buscar
							</v-btn>
						</v-flex>
						<v-flex ml-2>
							<v-btn
								color="error"
								class="ma-0 mt-3 btn-accounting"
								@click="clearAccouting"
							>
								Limpiar
							</v-btn>
						</v-flex>
					</v-layout>
				</v-flex>
				<v-flex xs12 v-if="showAccouting">
					<v-btn
						:disabled="openMobile"
						color="blue"
						class="ma-0 btn-accounting mt-3 desktop"
						@click="openMobileAccouting"
					>
						Ver Asientos Contable
					</v-btn>
				</v-flex>
			</v-layout>
			<v-layout row justify-end wrap>
				<v-flex xs2>
					<BaseSelect
						:disabled="!model.moduleId"
						class="select-accouting"
						label="Estado de asientos"
						item-text="name"
						item-value="id"
						:height="38"
						v-model="model.status"
						:items="status"
						:value="model.status"
						@input="setStatus"
					/>
				</v-flex>
				<v-flex xs2 sm2 md2 px-2>
					<BaseSelect
						:disabled="!model.moduleId"
						class="select-accouting"
						label="Tipo de Asientos"
						item-text="name"
						item-value="id"
						:height="38"
						v-model="model.square"
						:items="typesModule"
						:value="model.square"
						@input="setTypes"
					/>
				</v-flex>
				<v-flex xs3 sm2 md2 px-2 pt-2>
					<v-btn
						:disabled="disabledConfirm || flagNoConfirm || flagStatusAccounting || (model.status === 3 && model.square === 2)"
						color="#2196f3"
						class="btnSaveAccounting"
						@click="saveAccouting"
					>
						Confirmar Asiento
						<v-icon dark>
							check_circle
						</v-icon>
					</v-btn>
				</v-flex>
			</v-layout>
		</div>
		<div class="row-mobile">
			<v-layout row wrap mt-4>
				<v-flex xs12 sm12 lg6 px-2 v-if="listAccounting && !openMobile">
					<app-table
	:check-all="checkAll"
	:columns="columns"
	:rows="rows"
	flag-title
	:items-total-quantity="itemsTotalQuantity || rows.length"
	:items-quantity="rows.length"
	:last-page="lastPage"
	:title="titleModule"
	:input-search="false"
	:current-page="currentPage"
	:created-add="false"
	selectable
	@on-search-event="onSearch"
	@row-is-selected="rowIsSelected"
	@on-selected-all="selectedAll"
	@on-page="changePage"
>
	<template slot="rows" slot-scope="props">
		<!-- Aplicar el color a cada celda (td) -->
		<td
			style="height: 50px; font-size: 13px; width: 80px;"
			v-show="showRow(columns, 1)"
		>
			{{ validateDateRow(props.row) }}
		</td>
		<td
			style="height: 50px; font-size: 13px;"
			v-show="showRow(columns, 2)"
			class="entity"
		>
			<p class="mb-0">
				<span class="desktop">Numero de documento: </span>
				<span v-if="props.row.documentNumberComplete && !mobile">
					<span v-if="props.row.documentNumberComplete && props.row.documentNumberComplete.length < 17">{{
						props.row.transactionId ||
							props.row.documentNumberComplete ||
							props.row.documentAccountStatusId ||
							props.row.code ||
							props.row.gloss ||
							props.row.documentNumber
					}}</span>
					<v-tooltip top v-else>
						<span slot="activator">{{
							props.row.id ||
								props.row.documentNumberComplete ||
								props.row.documentAccountStatusId ||
								props.row.code ||
								props.row.gloss ||
								props.row.documentNumber
						}}</span>
						<span>{{
							props.row.transactionId ||
								props.row.documentNumberComplete ||
								props.row.documentAccountStatusId ||
								props.row.code ||
								props.row.gloss ||
								props.row.documentNumber
						}}</span>
					</v-tooltip>
				</span>
				<span v-else>
					{{
						props.row.documentNumberComplete ||
							props.row.documentAccountStatusId ||
							props.row.code ||
							props.row.gloss ||
							props.row.documentNumber ||
							props.row.id
					}}
				</span>
			</p>
		</td>
		<td
			style="height: 50px; font-size: 13px;"
			v-show="showRow(columns, 3)"
		>
			{{
				props.row.documents && props.row.documents != null
					? props.row.documents.toString()
					: props.row.observations ||
					props.row.documentNumber ||
					props.row.sendKardexMessage ||
					props.row.gloss ||
					props.row.description
			}}
		</td>

		<td v-show="showRow(columns, 4)" style="display: grid; place-items: center; height: 50px; width: 90px;">
	<div 
		class="tooltip-container" 
		:style="{ backgroundColor: props.row.color }"
	>
		<div class="tooltip-content">
			{{ props.row.moduleCode }}
		</div>
	</div>
</td>

		<td
			style="text-align: right; padding-right: 5px; height: 50px; font-size: 13px; color: #02979b; font-weight: bold;"
			v-show="showRow(columns, 5)"
		>
			{{  props.row.amount || props.row.totalDebe | formatAmount }}
		</td>
	</template>
</app-table>
				</v-flex>
				<v-flex
					xs12
					sm12
					lg6
					px-2
					class="content-acc"
					:class="{ open: openMobile }"
				>
					<app-table
						:created-add="false"
						:check-all="checkAllAccounting"
						:columns="columnsSeat"
						:rows="rowsSeat"
						:items-total-quantity="itemsTotalQuantityDetails"
						:items-quantity="rowsSeat.length"
						selectable
						delete-seat
						:tooltip-delete="deleteTooltip"
						show-accounting
						flag-title
						:title="titleModuleSeat"
						:current-page="currentPageDetail"
						:input-search="false"
						:disabled-edit-accou="!rowsSeat.length > 0"
						:show-table-accounting="showDetailAccounting"
						:rows-details="rowsDetails"
						:last-page="lastPageDetails"
						@delete-seat="runAction('delete-seat')"
						@on-selected-all="selectedAllSeat"
						@on-page="onPage"
						@row-is-selected="rowIsSelectedAccounting"
						@edit-accouting="goToEditAccouting"
					>
						<template slot="rows" slot-scope="props">
							<td
								style="height: 50px; font-size: 13px;"
								v-show="showRow(columnsSeat, 1)"
							>
								{{ props.row.code }}
							</td>
							<td v-show="showRow(columnsSeat, 2)" style="display: grid; place-items: center; height: 50px; width: 90px;">
	<div 
		class="tooltip-container" 
		:style="{ backgroundColor: props.row.color }"
	>
		<div class="tooltip-content">
			{{ props.row.moduleCode }}
		</div>
	</div>
</td>
							<td
								style="height: 50px; font-size: 13px;"
								v-show="showRow(columnsSeat, 3)"
								class="gloss"
							>
								<p class="mb-0">
									<span class="desktop">Descripción:</span>
									<span v-if="props.row.gloss && !mobile">
										<span v-if="props.row.gloss.length < 17">{{
											props.row.gloss
										}}</span>
										<v-tooltip top v-else>
											<span slot="activator">{{
												props.row.gloss | limitTo(17)
											}}</span>
											<span>{{ props.row.gloss }}</span>
										</v-tooltip>
									</span>
									<span v-else>
										{{ props.row.gloss }}
									</span>
								</p>
							</td>
							<td
								style="height: 50px; font-size: 13px;"
								v-show="showRow(columnsSeat, 4)"
							>
								{{ props.row.date | exactDate }}
							</td>
							<td
								style="height: 50px; font-size: 13px;"
								v-show="showRow(columnsSeat, 5)"
							>
								<app-tooltip-button
									:color="statusColor(props.row)"
									icon="radio_button_checked"
									:text="statusName(props.row)"
								/>
							</td>
							<td
								style="text-align: right; height: 50px; font-size: 11px;"
								v-show="showRow(columnsSeat, 6)"
								class="blue-debe"
							>
								{{  props.row.totalDebe | formatAmount }}
							</td>
							<td
								style="text-align: right; height: 50px; font-size: 11px;"
								v-show="showRow(columnsSeat, 7)"
								class="red-haber"
							>
								{{ props.row.totalHaber | formatAmount }}
							</td>
							<td
								style="height: 50px; font-size: 13px;"
								v-show="showRow(columnsSeat, 8)"
							>
								<app-tooltip-button
									color="blue"
									icon="remove_red_eye"
									text="Ver Detalle"
									:width="17"
									@click-icon="openDetail(props.row)"
								/>
							</td>
						</template>
					</app-table>
				</v-flex>
			</v-layout>
			<!-- Modal para mostrar los detalles de los asientos -->
			<v-dialog v-model="dialogDetailAccounting" max-width="950">
				<v-card>
					<v-layout pa-3>
						<v-flex>{{ nameAccouting }}</v-flex>
						<v-flex text-xs-right>
							<close-icon class="cursor-pointer" @click="closeDialog"></close-icon>
						</v-flex>
					</v-layout>
					<v-divider></v-divider>
					<v-layout wrap v-if="openDetailSeat">
						<v-flex xs12 class="title-heading pt-1">
							Detalles
						</v-flex>
						<v-flex xs12 class="body-seat-form">
							<v-layout row wrap align-start>
								<v-flex xs8>
									<v-layout row wrap align-end>
										<v-flex xs6 pr-2>
											<v-select
												:items="accounts"
												item-text="fullName"
												item-value="id"
												solo
												autocomplete
												hide-details
												class="filter-select shadow-inset select-autocomplete-create"
												v-model="modelDetail.accountingAccountId"
												return-object
												@input="setData">
											</v-select>
										</v-flex>
										<v-flex xs6>
											<app-input-text
												disabled
												readonly
												:text="accountingAccount.name"/>
										</v-flex>
									</v-layout>
								</v-flex>
								<v-flex xs4 pl-2>
									<app-input-text
										model="reference"
										placeholder="Referencia"
										:text="modelDetail.reference"
										@input="setModelData"
									></app-input-text>
								</v-flex>
								<v-flex xs4 pr-2>
									<app-input-text
										model="concept"
										placeholder="Concepto"
										:text="modelDetail.concept"
										@input="setModelData"
									></app-input-text>
								</v-flex>
								<v-flex xs4>
									<autocomplete-component
										append-icon="expand_more"
										http-code="$http"
										:item="modelDetail.costCenterId"
										item-text="name"
										item-value="id"
										:items="costCenters"
										model="costCenterId"
										placeholder-value="Centro de costos"
										prop="name"
										autocomplete
										prop-search="name"
										:disabled="validCostCenter"
										:resource-url="`cost-center/${params.subsidiaryId}/subsidiary`"
										return-object
										select-create
										@return-data="setCostCenter"
									></autocomplete-component>
								</v-flex>
								<v-flex xs3 pl-2>
									<app-input-text
										model="amount"
										placeholder="Importe"
										:text="modelDetail.amount"
										tooltip-message="Ingresar el importe con signo negativo (-) para crear detalles de tipo HABER"
										tooltip-on-focused
										type="number"
										@input="setModelData"
									></app-input-text>
									<span
										v-if="modelDetail.amount !== 0"
										:class="`${modelDetail.amount < 0 ? 'error' : 'secondary'}--text caption`">
										Detalle de tipo {{ typeDetail }}
									</span>
								</v-flex>
								<v-flex xs1 text-xs-center pt-2>
									<v-tooltip top>
										<button
											class="btn-create-seat"
											slot="activator"
											type="button"
											:disabled="validFields || validInsertCostCenter"
											@click="saveNewDetailSeat"
										>
											<v-icon color="secondary" size="26">add_circle</v-icon>
										</button>
										<span v-if="validFields">Completar todos los campos</span>
										<span v-else-if="validInsertCostCenter">Debe escoger un centro de costo</span>
										<span v-else>Agregar</span>
									</v-tooltip>
								</v-flex>
							</v-layout>
						</v-flex>
					</v-layout>
					<div class="pa-3">
						<app-table
							:rows="rowsDetailModal"
							:columns="columnsDetail"
							:input-search="false"
							:created-add="false"
							:t-foot="false"
							:main-list="false"
						>
							<template slot="rows" slot-scope="props">
								<td v-show="showRow(columnsDetail, 1)" 	class="is-not-selectable account">
									<template v-if="props.row.edit && props.row.flagEdit !== 0">
										<autocomplete-component
											append-icon="expand_more"
											class="edit-inline"
											http-code="$http"
											id="focus-edit-inline"
											:item="props.row.accountingAccount"
											item-text="fullName"
											item-value="id"
											:items="accounts"
											autocomplete
											model="accountingAccount"
											placeholder-value="Buscar cuenta contable"
											placeholder-input="Nombre de la cuenta"
											prop="account"
											prop-search="fullName"
											return-object
											select-create
											tabindex="1"
											@return-data="changeAccount({
												row: props.row,
												value: $event,
												index: props.index,
											})"
										></autocomplete-component>
									</template>
									<template v-else>
										<div>
											<span>{{ props.row.accountingAccount.account }}</span>
										</div>
									</template>
								</td>
								<td v-show="showRow(columnsDetail, 2)">
									{{
										props.row.accountingAccount
											? props.row.accountingAccount.name
											: null
									}}
								</td>
								<td v-show="showRow(columnsDetail, 3)" class="reference">
									<p class="mb-0">
										<span class="desktop"
											>Referencia: {{ props.row.reference }}</span
										>
										<span v-if="props.row.reference && !mobile">
											<span>{{ props.row.reference }}</span>
										</span>
									</p>
								</td>
								<td v-show="showRow(columnsDetail, 4)">
									{{ props.row.concept }}
								</td>
								<td v-show="showRow(columnsDetail, 5)">
									{{ getType(props.row) }}
								</td>
								<td v-show="showRow(columnsDetail, 6)" v-if="props.row.edit && props.row.flagEdit !== 0">
									<app-input-text
										class="edit-inline"
										model="amountSeat"
										:text="props.row.amount | round"
										:value="props.row.amount | round"
										@change="
											changeAmountSeat({
												row: props.row,
												value: $event,
												index: props.index,
											})
										"
									></app-input-text>
								</td>
								<td style="text-align: end; padding: 0 5px" v-show="showRow(columnsDetail, 6)" v-else>
									{{ props.row.amount ? props.row.amount : 0 | formatAmount }}
								</td>
								<td v-show="showRow(columnsDetail, 7)">
									<template v-if="props.row.edit">
										<autocomplete-component
											append-icon="expand_more"
											class="edit-inline"
											http-code="$http"
											id="focus-edit-inline"
											:item="props.row.costCenter"
											item-text="name"
											item-value="id"
											:items="costCenters"
											autocomplete
											model="costCenter"
											placeholder-value="Buscar centro de costos"
											placeholder-input="Nombre del centro de costos"
											prop="name"
											prop-search="name"
											return-object
											select-create
											tabindex="1"
											@return-data="changeCostCenter({
												row: props.row,
												value: $event,
												index: props.index,
											})"
										></autocomplete-component>
										<span v-if="flagValidNumberAccount" class="msg-error">Debe seleccionar un centro de costo</span>
									</template>
									<template v-else>
										<div>
											<span>{{ props.row.costCenter && props.row.costCenter.name ? props.row.costCenter.name : null }}</span>
										</div>
									</template>									
								</td>
								<td v-show="showRow(columnsDetail, 8)">
									<!-- <button
										v-if="props.row.edit"
										class="btn-edit-detail"
										type="button"
										tabindex="6"
										@click="saveSeat(props.row, props.index)"
									>
										Aceptar
									</button> -->
									<v-layout>
									<app-tooltip-button
										color="success"
										:disabled="model.status === 2"
										img="/static/img/actions-list/edit.svg"
										:text="model.status === 1 ? 'Deshabilitado' : 'Editar'"
										:width="16"
										@click-icon="editSeats(props.row, props.index)"
									/>
									<app-tooltip-button
											v-if="props.row.flagEdit === 1"
											color="error"
											:disabled="model.status === 1"
											img="/static/img/actions-list/delete.svg"
											:text="model.status === 1 ? 'Deshabilitado' : 'Eliminar'"
											:width="16"
											@click-icon="deleteSeat(props.row, props.index)"
										/>
									</v-layout>
								</td>
							</template>
							<span
								v-if="dataSeat.code"
								slot="text"
								class="wrapper-text"
							>
								<v-tooltip top>
										<!-- :disabled="flagDisabledAddSeat || toDeclare" -->
									<v-btn
										slot="activator"
										color="#33cfc7"
										class="btn-auto pa-0 ma-0 btn-add no-movil border-radius"
										type="button"
										@click="onAddDetail"
										>
										<v-icon color="white" size="19">add</v-icon>
									</v-btn>
									<span>Nuevo Detalle (ctrl + alt + k)</span>
								</v-tooltip>
							</span>
						</app-table>
					</div>
					<v-divider></v-divider>
					<v-card-actions>
						<div class="btn-actions">
							<v-tooltip top>
								<button
									slot="activator"
									class="btn-seat btn-save"
									:disabled="isLoading || squareAmounts || flagValidNumberAccount || validateSomeForceInsertCenterCost || validSquareAmounts"
									type="button"
									@click="saveAllDetailsEdits"
								>
									Guardar
								</button>
								<span v-if="squareAmounts">Debe cuadrar el asiento para guardar</span>
								<span v-else>Guardar</span>
							</v-tooltip>
							<button
								class="btn-seat btn-clean"
								type="button"
								@click="closeDialog"
							>
								Cancelar
							</button>
						</div>
					</v-card-actions>
				</v-card>
			</v-dialog>
			<v-dialog v-model="dialogAction" max-width="400">
				<v-card>
					<v-card-text class="title text-xs-center pt-4"
						>¿ Desea contabilizar los registros ?</v-card-text
					>
					<v-card-text class="titleNumberSeat text-xs-center pt-1"
						>Nº de Asientos a contabilizar:
						{{
							this.dataSelected.length === 0 ? 1 : this.dataSelected.length
						}}</v-card-text
					>
					<v-card-actions class="justify-center pb-4">
						<v-btn
							@click="closeDialogAction"
							type="button"
							color="error"
							class="btn-action mr-1 white--text"
						>
							NO
						</v-btn>
						<v-btn
							@click="postRecord"
							type="button"
							color="success"
							class="btn-action ml-1 white--text"
						>
							SI
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
			<v-dialog v-model="dialogWait" max-width="400" persistent>
				<v-card class="text-card">
					<v-card-text>
						<div class="loading-icon">
							<div class="spinner"></div>
							<p class="title text-xs-center pt-4">
								Espere un momento, se estan creando los asientos.
							</p>
						</div>
					</v-card-text>
				</v-card>
			</v-dialog>

			<v-dialog
				content-class="confirmation-dialog"
				v-model="cancelModal"
				max-width="400"
			>
				<v-card class="pa-4">
					<v-card-text class="title text-xs-center pt-4"
						>¿Desea eliminar los asientos seleccionados?</v-card-text
					>
					<v-card-actions class="justify-center pb-4">
						<button
							:disabled="flagWait"
							type="button"
							class="btn-modal cancelSeat mr-2"
							@click="setId"
						>
							No
						</button>
						<button
							:disabled="flagWait"
							type="button"
							class="btn-modal save ml-2"
							@click="onDeleteSeat"
						>
							Si
						</button>
					</v-card-actions>
				</v-card>
			</v-dialog>
			<v-dialog
				content-class="confirmation-dialog"
				v-model="dialogDeleteAccounting"
				max-width="400"
			>
				<v-card>
					<v-card-text class="title text-xs-center pt-4">{{
						titleDialogDelete
					}}</v-card-text>
					<v-card-actions class="justify-center pb-4">
						<button
							type="button"
							class="btn cancel"
							@click="closeDialogAccouting"
						>
							No
						</button>
						<button type="button" class="btn agree">
							Si
						</button>
					</v-card-actions>
				</v-card>
			</v-dialog>
			<v-dialog
				content-class="confirmation-dialog"
				v-model="modalDeleteSeat"
				max-width="400"
				persistent
			>
				<v-card>
					<v-card-text class="title text-xs-center pt-4">{{
						titleDialogDelete
					}}
						<p class="mt-2">Está seguro de eliminar el detalle, el asiento podría quedar descuadrado.</p>
					</v-card-text>
					<v-card-actions class="justify-center pb-4">
						<button
							type="button"
							class="btn cancel"
							@click="closeModalDeleteSeat"
						>
							No
						</button>
						<button type="button" class="btn agree" @click="eliminateSeat">
							Si
						</button>
					</v-card-actions>
				</v-card>
			</v-dialog>
			<v-dialog v-model="modalWaitSeats" max-width="400" persistent>
  <v-card>
    <v-card-text>
      <v-stepper v-model="e13" vertical>
        <!-- Generar un paso por cada módulo -->
        <v-stepper-step
          v-for="(moduleCode, index) in newModules"
          :key="moduleCode"
          :step="index + 1"
          :complete="stepStatus[moduleCode] === 'complete' || stepStatus[moduleCode] === 'error'"
          :error="stepStatus[moduleCode] === 'error'"
          :color="stepStatus[moduleCode] === 'error' ? 'red' : '#02979b'"
          :complete-icon="stepStatus[moduleCode] === 'complete' ? 'check' : 'error'"
        >
          {{ moduleCode }} <!-- Nombre del módulo -->
          <small v-if="stepStatus[moduleCode] === 'error'">Hubo un error, al crear los asientos</small>
          <small v-if="stepStatus[moduleCode] === 'complete'">Se crearon los asientos correctamente</small>
        </v-stepper-step>
      </v-stepper>
    </v-card-text>
    <v-card-actions>
      <!-- Barra de progreso -->
	  	<v-layout row wrap justify-center>
			<v-flex xs12>
			<v-progress-linear
				v-model="progress"
				:active="modalWaitSeats"
				:indeterminate="false"
				color="success"
			></v-progress-linear>
			</v-flex>
				<v-btn
					:disabled="flagbtnCloseSeatModal"
					color="red"
					class="ma-0 btn-accounting mt-3"
					@click="closeModalWaitSeat"
				>
					Cerrar
				</v-btn>
		</v-layout>
    </v-card-actions>
  </v-card>
</v-dialog>
		</div>
		<!--<section class="modal-filter-footer">
		  <modal-sidebar-button
			  :is-loading="disabledConfirm"
			  success-text="Confirmar"
			  @accept-button-clicked="saveAccouting"
		  ></modal-sidebar-button>
	  </section> -->
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import appInputText from '@/components/autocomplete/app-input-text';
import actionBar from '@/components/shared/action-bar/action-bar';
import appTooltipButton from '@/components/shared/app-tooltip-button';
import appDateSelect from '@/components/shared/app-date-select';
import BaseSelect from '@/components/shared/inputs/base-select';
import { endOfMonth, format, subDays } from 'date-fns';
import dateComponent from '@/components/autocomplete/date-component';
import lib from '@/shared/lib';
import autocompleteComponent from '@/components/autocomplete/autocomplete-component';
import closeIcon from '../../components/shared/icons/close.icon';

const { getDeeper } = lib;
let colorIndex = 0;

async function created() {
	this.loadModules();
	this.model.startDate = format(subDays(this.$today, 7), 'YYYY-MM-DD');
	this.model.endDate = this.$today;
	window.addEventListener('resize', this.reziseMobile);
	this.model.status = 3;
	this.model.accountingSeat = 0;
	if (this.model.accountingSeat === 0) {
		this.flagStateRecord = false;
	}
	this.reziseMobile();
	this.subsidiaryId = this.currentSubsidiary.id;
	const { data: response } = await this.$http.get(`settings/${this.currentSubsidiary.customerId}/${this.currentSubsidiary.id}`);
	this.settings = response.additionalSettings;
	this.loadAccounts();
	this.loadCostCenter();
}

async function loadModules() {
	const params = {
		subsidiaryId: this.subsidiaryId || this.currentSubsidiary.id,
	};
	({ data: this.modules } = await this.$http.get('type-register', { params }));
	if (this.modules.length === 1) {
		this.model.moduleId = this.modules[0].id;
	}
	this.modulesFilter = this.modules;
	const newArrayModules = [
		{ code: 'CTAXCOBFAC', name: 'OTROS DOC. CXC' },
		{ code: 'CTAXPAGFAC', name: 'OTROS DOC. CXP' },
		{ code: 'TODOS', name: 'TODOS' },
	];
	this.modulesFilter = this.modulesFilter.concat(newArrayModules);
	this.modulesFilter = this.modulesFilter.map(module => ({
		...module,
		color: this.statusColorModules(module),
		name: this.statusNameModules(module),
	}));
}

function setModule(value) {
	this.model.moduleId = value;
	this.flagNewModules = value === 'CTAXCOBFAC' || value === 'CTAXPAGFAC';
	this.titleModule = `REGISTROS DE MÓDULO ${this.model.moduleId}`;
	this.titleModuleSeat = `ASIENTOS CREADOS MÓDULO  ${this.model.moduleId}`;
	const index = this.modules.findIndex(m => m.code === value);
	if (index > -1) {
		this.valuesShow = this.modules[index].templateJson || {};
	}
}
async function setStatusRecords(value) {
	this.model.accountingSeat = value;
	this.flagStateRecord = false;
}
async function setStatus(value) {
	this.model.status = value;
	if (this.model.status === 1) {
		this.flagStatusAccounting = true;
	} else {
		this.flagStatusAccounting = false;
	}
	this.loadAccountingDetail();
	this.selectedAllSeat();
}
async function setTypes(value) {
	this.model.square = value;
	if (this.model.square === 2) {
		this.flagNoConfirm = true;
	} else {
		this.flagNoConfirm = false;
	}
	await this.loadAccountingDetail.call(this);
	this.selectedAllSeat();
}

async function onPage(page) {
	this.currentPageDetail = page;
	await this.loadAccountingDetail.call(this);
}

async function loadAccountingDetail() {
	const params = {
		subsidiaryId: this.subsidiaryId || this.currentSubsidiary.id,
		status: this.model.status,
		moduleCode: this.model.moduleId === 'TODOS' ? null : this.verifyNewModules(this.model.moduleId),
		startDate: this.model.startDate,
		endDate: this.model.endDate,
		square: this.model.square,
		page: this.currentPageDetail,
		limit: 100,
	};
	try {
		const response = await this.$http.get('accounting-seats', { params });
		this.lastPageDetails = Number(response.headers['x-last-page']);
		this.itemsTotalQuantityDetails = Number(response.headers['x-quantity']);
		this.rowsSeat = response.data.map((row) => {
			const newRow = { ...row };
			const module = this.modulesFilter.find(mod => mod.code === row.typeRegister.code);
			newRow.moduleCode = module.code;
			newRow.color = module ? module.color : '#03888c';
			newRow.isSelected = false;
			return newRow;
		});
	} catch (error) {
		this.showGenericError();
	} finally {
		const activeFlagPage = true;
		this.dialogLoading = false;
		this.loadAccounting(activeFlagPage);
	}
}

function verifyNewModules(code) {
	if (code === 'CTAXCOBFAC' || code === 'CTAXPAGFAC') {
		if (code === 'CTAXCOBFAC') {
			return 'CTAXCOB';
		}
		return 'CTAXPAG';
	}
	return code;
}

async function loadAccounting(flagPage) {
	const flagActivePage = flagPage;
	this.loading = true;
	if (this.model.moduleId !== 'Contabilidad') {
		if (this.model.moduleId === 'VENTA') {
			this.model.moduleId = 1;
		}
		if (this.model.moduleId === 'COMPRA') {
			this.model.moduleId = 2;
		}
		if (this.model.moduleId === 'CTAXPAG' || this.model.moduleId === 'CTAXPAGFAC') {
			this.model.moduleId = 3;
		}
		if (this.model.moduleId === 'CTAXCOB' || this.model.moduleId === 'CTAXCOBFAC') {
			this.model.moduleId = 4;
		}
		if (this.model.moduleId === 'INGRESOS') {
			this.model.moduleId = 6;
		}
		if (this.model.moduleId === 'EGRESOS') {
			this.model.moduleId = 7;
		}
		if (this.model.moduleId === 'CAJA') {
			this.model.moduleId = 8;
		}
		if (this.model.moduleId === 'BANCO') {
			this.model.moduleId = 9;
		}
		if (this.model.moduleId === 'NOMINA') {
			this.model.moduleId = 10;
		}
		if (this.model.moduleId === 'TODOS') {
			this.model.moduleId = 11;
		}
		if (this.model.moduleId !== 11) {
			this.dialogLoading = true;
		}
		const params = {
			accountingSeat: this.model.accountingSeat,
			startDate: this.model.startDate,
			endDate: this.model.endDate,
			search: this.model.search,
			subsidiaryId: this.subsidiaryId || this.currentSubsidiary.id,
			page: flagActivePage ? 1 : this.currentPage,
			limit: this.model.moduleId === 11 ? 50 : 100,
			flagForNull:
				this.model.moduleId === 1 || this.model.moduleId === 2 ||
					this.model.moduleId === 11 ? 1 : null,
		};
		if (this.flagNewModules) {
			params.flagFacWithDocStatus = true;
		}
		try {
			const response = await this.$http.get(
				`registers/accounting-seat/${this.model.moduleId}?&sortField=created_at`,
				{ params },
			);
			this.itemsTotalQuantity = Number(response.headers['x-quantity']);
			this.rows = response.data.map((row) => {
				const newRow = { ...row };
				newRow.isSelected = false;
				const flag = Object.keys(this.valuesShow).length;
				const module = this.modulesFilter.find(mod => mod.code === row.moduleCode);
				newRow.color = module ? module.color : '#03888c';
				const searchDate = flag ? this.valuesShow.date.split('.') : null;
				const searchEntity = flag ? this.valuesShow.entity.split('.') : null;
				const searchReference = flag
					? this.valuesShow.reference.split('.')
					: null;
				const searchAmount = flag ? this.valuesShow.amount.split('.') : null;
				newRow.dateToShow = searchDate ? getDeeper(...searchDate)(row) : null;
				newRow.entityToShow = searchEntity
					? getDeeper(...searchEntity)(row)
					: null;
				newRow.referenceToShow = searchReference
					? getDeeper(...searchReference)(row)
					: null;
				newRow.amountToShow = searchAmount
					? getDeeper(...searchAmount)(row)
					: null;
				return newRow;
			});
			this.lastPage = Number(response.headers['x-last-page']);
		} catch (error) {
			if (error.status === 500) {
				this.showGenericError();
			} else if (error.status === 400) {
				if (error.data.message === 'SUBSIDIARY_NOT_CONFIG_FILTERS') {
					this.showGenericError(
						'Empresa sin configuración de integración a Firebase',
					);
				}
			}
		} finally {
			this.dialogLoading = false;
			if (this.model.moduleId === 1) {
				this.model.moduleId = 'VENTA';
			}
			if (this.model.moduleId === 2) {
				this.model.moduleId = 'COMPRA';
			}
			if (this.model.moduleId === 3 && this.flagNewModules) {
				this.model.moduleId = 'CTAXPAGFAC';
			}
			if (this.model.moduleId === 4 && this.flagNewModules) {
				this.model.moduleId = 'CTAXCOBFAC';
			}
			if (this.model.moduleId === 3) {
				this.model.moduleId = 'CTAXPAG';
			}
			if (this.model.moduleId === 4) {
				this.model.moduleId = 'CTAXCOB';
			}
			if (this.model.moduleId === 6) {
				this.model.moduleId = 'INGRESOS';
			}
			if (this.model.moduleId === 7) {
				this.model.moduleId = 'EGRESOS';
			}
			if (this.model.moduleId === 8) {
				this.model.moduleId = 'CAJA';
			}
			if (this.model.moduleId === 9) {
				this.model.moduleId = 'BANCO';
			}
			if (this.model.moduleId === 10) {
				this.model.moduleId = 'NOMINA';
			}
			if (this.model.moduleId === 11) {
				this.model.moduleId = 'TODOS';
			}
			this.loading = false;
		}
	} else {
		this.loading = false;
	}
}

function rowIsSelected({ id, isSelected }) {
	this.checkAll = this.rows.every(row => row.isSelected);
	if (isSelected) {
		this.dataSelected.push(this.rows.find(row => row.id === id));
	} else {
		const index = this.dataSelected.findIndex(row => row.id === id);
		this.dataSelected.splice(index, 1);
	}
}

function clearAccouting() {
	this.model.moduleId = null;
	this.showAccouting = false;
	this.valuesShow = {};
}

function onSearch(value) {
	this.model.search = value || null;
	this.loadAccounting();
}

function selectedAll(checked) {
	this.checkAll = checked;
	this.rows = this.rows.map((row) => {
		const newRow = { ...row };
		newRow.isSelected = checked;
		return newRow;
	});
	this.dataSelected = this.rows.filter(r => r.isSelected);
}
function selectedAllSeat(checked) {
	this.checkAllAccounting = checked;
	this.rowsSeat = this.rowsSeat.map((row) => {
		const newRow = { ...row };
		newRow.isSelected = checked;
		return newRow;
	});
	this.dataSelectedAccounting = this.rowsSeat.filter(r => r.isSelected);
}

function openDetail(row) {
	this.dialogDetailAccounting = true;
	this.dataSeat = { ...row };
	this.nameAccouting = `${row.code} - ${row.gloss}`;
	this.rowsDetailModal = row.details.map((det) => {
		const newDet = { ...det };
		newDet.edit = false;
		return newDet;
	});
}

function changePage(page) {
	this.currentPage = page;
	this.model.page = page;
	this.loadAccounting();
	this.dataSelected = [];
}

function statusColor({ status }) {
	return status === 1 ? 'success' : 'error';
}

function statusName({ status }) {
	return status === 1 ? 'Correcto' : 'Pendiente';
}

function statusColorModules() {
	// Lista de 13 colores
	const colors = [
		'#03888c', // Color base
		'#4caf50', // Verde azulado oscuro
		'#00A896', // Verde azulado claro
		'#7FC1C0', // Cian pastel suave
		'#B2DFDB', // Cian muy claro
		'#FFCC80', // Amarillo pastel
		'#FFAB91', // Coral pastel
		'#EF9A9A', // Rojo pastel
		'#B39DDB', // Violeta pastel
		'#90CAF9', // Azul pastel
		'#80CBC4', // Verde azulado pastel
		'#A5D6A7', // Verde pastel
		'#F48FB1', // Rosa pastel
	];
	const color = colors[colorIndex % colors.length];
	colorIndex += 1; // Incrementar el índice para el próximo código
	return color;
}

function statusNameModules({ name }) {
	// Devuelve el nombre del elemento
	return name;
}

async function saveAccouting() {
	const body = {
		ids: this.dataSelectedAccounting.map(accounting => accounting.id),
	};
	try {
		await this.$http.patch('accounting-seat/confirm', body);
		this.showNotification('Los asientos fueron asignados correctamente');
		this.loadAccountingDetail();
		this.loadAccounting();
		this.dataSelectedAccounting = [];
	} catch (error) {
		this.showGenericError();
	} finally {
		this.selectedAllSeat();
	}
}

function rowIsSelectedAccounting({ id, isSelected }) {
	this.checkAllAccounting = this.rowsSeat.every(row => row.isSelected);
	if (isSelected) {
		this.dataSelectedAccounting.push(this.rowsSeat.find(row => row.id === id));
	} else {
		const index = this.dataSelectedAccounting.findIndex(row => row.id === id);
		this.dataSelectedAccounting.splice(index, 1);
	}
}

function closeDialog() {
	this.nameAccouting = null;
	this.dialogDetailAccounting = false;
}

function getType({ amount }) {
	return amount < 0 ? 'H' : 'D';
}

function getDate({ value, model }) {
	if (model === 'startDate') {
		this.model[model] = format(value, 'YYYY-MM-DD');
		this.model.endDate = format(endOfMonth(value), 'YYYY-MM-DD');
	} else if (model === 'endDate') {
		this.model[model] = format(value, 'YYYY-MM-DD');
	}
}

function disabledConfirm() {
	return !this.dataSelectedAccounting.length > 0;
}

async function postRecord() {
	if (this.model.moduleId === 1) {
		this.model.moduleId = 'VENTA';
	}
	if (this.model.moduleId === 2) {
		this.model.moduleId = 'COMPRA';
	}
	if (this.model.moduleId === 3) {
		this.model.moduleId = 'CTAXPAG';
	}
	if (this.model.moduleId === 4) {
		this.model.moduleId = 'CTAXCOB';
	}
	if (this.model.moduleId === 6) {
		this.model.moduleId = 'INGRESOS';
	}
	if (this.model.moduleId === 7) {
		this.model.moduleId = 'EGRESOS';
	}
	if (this.model.moduleId === 8) {
		this.model.moduleId = 'CAJA';
	}
	if (this.model.moduleId === 9) {
		this.model.moduleId = 'BANCO';
	}
	if (this.model.moduleId === 10) {
		this.model.moduleId = 'NOMINA';
	}
	if (this.model.moduleId === 'CTAXCOBFAC') {
		this.model.moduleId = 'CTAXCOB';
	}
	if (this.model.moduleId === 'CTAXPAGFAC') {
		this.model.moduleId = 'CTAXPAG';
	}
	if (this.model.moduleId === 'TODOS') {
		this.modalWaitSeats = true;
		this.flagbtnCloseSeatModal = true;
		this.newModules = [...new Set(this.dataSelected.map(p => p.moduleCode))];
		// Inicializar el estado de cada módulo
		this.newModules.forEach((moduleCode) => {
			this.$set(this.stepStatus, moduleCode, null);
		});
		const progressIncrement = 100 / this.newModules.length;
		// Procesar cada módulo con forEach
		await this.newModules.reduce(async (previousPromise, moduleCode) => {
			await previousPromise; // Esperar a que la iteración anterior se complete
			try {
				// Filtrar dataSelected para el módulo actual
				const newDataSelected = this.dataSelected.filter(p => p.moduleCode === moduleCode);
				// Construir el body para la solicitud
				const body = {
					ruc: this.currentSubsidiary.documentNumber,
					documents: newDataSelected.map(p => p.id),
				};

				// Parámetros de la solicitud
				const subsidiaryId = this.subsidiaryId || this.currentSubsidiary.id;
				const params = {
					subsidiaryId,
				};

				if (moduleCode === 'CTAXCOBFAC' || moduleCode === 'CTAXPAGFAC') {
					params.flagFacWithDocStatus = true;
				}

				// Mostrar diálogo de espera
				this.dialogAction = false;

				// Consumir el servicio
				let newSetModule = moduleCode;
				if (newSetModule === 'CTAXCOBFAC') {
					newSetModule = 'CTAXCOB';
				} else if (newSetModule === 'CTAXPAGFAC') {
					newSetModule = 'CTAXPAG';
				}

				// Esperar 8 segundos antes de consumir el servicio
				await new Promise(resolve => setTimeout(resolve, 8000));
				// Consumir el servicio después de la espera
				await this.$http.post(
					`accounting-seat/${newSetModule}/multiple`, // Usar moduleCode en la URL
					body,
					{ params },
				);

				// Actualizar el estado del paso a "completado"
				this.$set(this.stepStatus, moduleCode, 'complete');
				this.showNotification(`Los registros del módulo ${moduleCode} se guardaron correctamente.`);
			} catch (error) {
				// Actualizar el estado del paso a "error"
				this.$set(this.stepStatus, moduleCode, 'error');
				// Manejo de errores
				if (error.response && error.response.status === 400) {
					this.showNotification(`Error en el módulo ${moduleCode}: ${error.response.data.message}`, 'warning');
				} else if (error.response && error.response.status === 500) {
					this.showNotification(`Error en el módulo ${moduleCode}: ${error.response.data.message}`, 'warning');
				} else {
					this.showGenericError();
				}
			} finally {
				// Incrementar el progreso
				this.progress += progressIncrement;
			}
		}, Promise.resolve());
		// Finalizar el proceso
		this.dataSelected = [];
		this.flagbtnCloseSeatModal = false;
		this.loadAccountingDetail();
		this.selectedAll();
	} else {
		const body = {
			ruc: this.currentSubsidiary.documentNumber,
			documents: this.dataSelected.map(p => p.id),
		};
		const subsidiaryId = this.subsidiaryId || this.currentSubsidiary.id;
		const params = {
			subsidiaryId,
		};
		if (this.flagNewModules) {
			params.flagFacWithDocStatus = true;
		}
		try {
			this.dialogAction = false;
			this.dialogWait = true;
			await this.$http.post(
				`accounting-seat/${this.model.moduleId}/multiple`,
				body,
				{ params },
			);
			this.showNotification('Los registros se guardaron correctamente.');
			this.dialogWait = false;
			this.closeDialogAction();
			// this.loadAccountingDetail();
			this.dataSelected = [];
		} catch (error) {
			this.dialogWait = false;
			if (error.data.message === 'SOME_WRONG_ACCOUNTING_SEATS') {
				this.showNotification('Existen detalles de uno o más asientos sin cuentas contables', 'warning');
			} else if (error.data.message === 'OUT_OF_SQUQRE_SEATS') {
				this.showNotification('Existen asientos Descuadrados', 'warning');
			} else {
				this.showGenericError();
			}
		} finally {
			this.loadAccountingDetail();
			this.selectedAll();
		}
	}
}

function closeDialogAction() {
	this.dialogAction = false;
}

function runAction({ codeWeb }) {
	if (codeWeb === 'post-record') {
		this.dialogAction = true;
	} else {
		this.rowsIds = this.rowsSeat
			.filter(i => i.isSelected === true)
			.map(row => row.id);
		this.rowIdsModules = this.rowsSeat
			.filter(i => i.isSelected === true)
			.map(row => ({
				id: row.id,
				moduleName: row.typeRegister.code,
				gloss: row.gloss,
				additionalInformation: row.additionalInformation ? row.additionalInformation : {},
			}));
		this.cancelModal = true;
	}
}

function valuesDisabled() {
	if (this.dataSelected.length < 1) {
		return [{ code: 'post-record', disabled: true }];
	}
	return [];
}

function getDataDate(val) {
	if (val === 1) {
		this.model.startDate = this.$today;
		this.model.endDate = this.$today;
		this.flagDate = false;
	} else if (val === 2) {
		this.model.startDate = format(subDays(this.$today, 1), 'YYYY-MM-DD');
		this.model.endDate = format(subDays(this.$today, 1), 'YYYY-MM-DD');
		this.flagDate = false;
	} else if (val === 3) {
		this.model.startDate = format(subDays(this.$today, 7), 'YYYY-MM-DD');
		this.model.endDate = this.$today;
		this.flagDate = false;
	} else if (val === 4) {
		const today = new Date(this.$today);
		const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
		this.model.startDate = firstDayOfMonth.toISOString().split('T')[0];
		this.model.endDate = this.$today;
		this.flagDate = false;
	} else if (val === 5) {
		const today = new Date(this.$today);
		// Set the startDate to the first day of the current year
		const firstDayOfYear = new Date(today.getFullYear(), 0, 1);
		this.model.startDate = firstDayOfYear.toISOString().split('T')[0];
		this.model.endDate = this.$today;
		this.flagDate = false;
	} else if (val === 6) {
		this.model.startDate = format(subDays(this.$today, 7), 'YYYY-MM-DD');
		this.model.endDate = this.$today;
		this.flagDate = true;
	}
}

function loadCont() {
	this.dataSelected = [];
	this.rowsSeat = [];
	this.rows = [];
	this.dialogLoading = true;
	this.showAccouting = true;
	this.loadAccountingDetail();
	this.selectedAllSeat();
	this.selectedAll();
}

function openDialogDelete() {
	this.titleDialogDelete = '¿Está seguro que desea eliminar el asiento?';
	this.dialogDeleteAccounting = true;
}

function closeDialogAccouting() {
	this.dialogDeleteAccounting = false;
}

function goToEditAccouting() {
	const routeData = this.$router.resolve({
		name: 'page-edit-accounting',
		params: {
			subsidiaryId: this.subsidiaryId || this.currentSubsidiary.id,
			moduleId: this.model.moduleId,
		},
	});
	window.open(routeData.href, '_blank');
}
function setId() {
	this.cancelModal = false;
}

function destroyed() {
	window.removeEventListener('resize', this.reziseMobile);
}
async function loadAccounts() {
	const params = {
		status: 1,
	};
	({ data: this.accounts } = await this.$http.get(
		`accounting-plan/${this.subsidiaryId}/subsidiary`, { params }));
}

async function loadCostCenter() {
	// const params = {
	// 	page: 1,
	// 	search: null,
	// };
	const response = await this.$http.get(`cost-center/${this.currentSubsidiary.id}/subsidiary`);
	this.costCenters = response.data;
}

function reziseMobile() {
	const windowWidth = window.innerWidth;
	this.mobile = windowWidth <= 768;
}
async function onDeleteSeat() {
	try {
		// Usamos map en lugar de forEach para obtener un array de promesas
		this.flagWait = true;
		const promises = this.rowIdsModules.map(async (item) => {
			const { id, moduleName, gloss, additionalInformation } = item;
			if (moduleName === 'CAJA' || moduleName === 'BANCO') {
				const numberDocument = gloss.match(/\d+/)[0];
				this.documentNumberUpdate = numberDocument;
			}
			const payload = {
				moduleCode: moduleName,
			};
			const params = {};
			if (additionalInformation && additionalInformation.flagFacWithDocStatus) {
				params.flagFacWithDocStatus = true;
			}
			const response =
				moduleName === 'COMPRA'
					? await this.$http.patch(
						`accounting-seat-cancel/${id}?flagCancel=${this.flagCancel}`,
						payload,
					)
					: await this.$http.patch(`accounting-seat-cancel/${id}`, payload, { params });

			if (response.status === 200) {
				if (moduleName === 'CAJA' || moduleName === 'BANCO') {
					await this.$http.patch(
						`accounting-seats-cash-bank-cancel?subsidiaryId=${this.currentSubsidiary.id}`,
						{ ids: [id] },
					);
				}
			}
		});
		// Esperar a que todas las promesas se resuelvan antes de continuar
		await Promise.all(promises);
	} catch (error) {
		this.showGenericError();
	} finally {
		// Llamar a onDeleteSeatMultiple después de que todas las llamadas se completen
		this.onDeleteSeatMultiple();
		this.selectedAllSeat();
	}
}
async function onDeleteSeatMultiple() {
	const ids = { ids: this.rowsIds };
	try {
		await this.$http.delete('accounting-seat', { data: ids });
		this.showNotification('La eliminación ha sido realizada correctamente.');
		this.closeModal();
		this.params.subsidiaryId =
			this.subsidiaryId || this.currentSubsidiary.id || null;
		if (this.rowsIds.indexOf(this.rowSelected.id) > -1) {
			this.dataSelected = [];
			this.rowsSeat = [];
			this.rowIdsModules = [];
			this.rowsIds = [];
		} else {
			this.dataSelected = [];
			this.rowsSeat = [];
			this.rowIdsModules = [];
			this.rowsIds = [];
		}
	} catch (err) {
		if (err.status === 500) {
			this.showGenericError();
		}
	} finally {
		await this.loadAccountingDetail.call(this);
		this.setId();
		this.flagWait = false;
	}
}
function openMobileAccouting() {
	this.openMobile = !this.openMobile;
}

function closeMobile() {
	this.detailJournalOpen = false;
	this.openMobile = false;
}

function verifySubsidiary() {
	if (Object.keys(this.currentSubsidiary).length > 0) {
		return true;
	}
	this.showNotification('Seleccione una Sucursal', 'warning');
	return false;
}

function editSeats(row, index) {
	this.indexRowDetail = index;
	// this.rowsDetailModal[index].edit = true;
	this.rowsDetailModal = this.rowsDetailModal.map((d, indexD) => {
		const newDataDetail = { ...d };
		newDataDetail.edit = indexD === index;
		return newDataDetail;
	});
	const firstDigit = row.accountingAccount.account.charAt(0);
	this.flagValidNumberAccount = ((Number(firstDigit) >= 4 && Number(firstDigit) <= 8)
		&& row.costCenterId === null);
	// if (this.flagValidNumberAccount) {
	// 	this.rowsDetailModal[index].costCenter = {};
	// 	this.rowsDetailModal[index].costCenterId = null;
	// }
	if (this.settings.autoCenterCost) {
		if ((Number(firstDigit) < 4 && Number(firstDigit) > 8)
			&& this.rowsDetailModal[index].costCenterId) {
			this.flagValidCostCenter = true;
		} else if ((Number(firstDigit) >= 4 && Number(firstDigit) <= 8)
			&& !this.rowsDetailModal[index].costCenterId) {
			this.flagValidCostCenter = true;
		} else if ((Number(firstDigit) >= 4 && Number(firstDigit) <= 8)
			&& this.rowsDetailModal[index].costCenterId) {
			this.flagValidCostCenter = false;
		}
	}
}

function changeAmountSeat(item) {
	const { row, value, index } = item;
	if (row.type === 1) {
		this.rowsDetailModal[index].amount =
			value < 0 ? Number(value) * -1 : Number(value);
		this.rowsDetailModal[index].amountDebe =
			value < 0 ? Number(value * -1) : Number(value);
	} else {
		this.rowsDetailModal[index].amount =
			value > 0 ? Number(value) * -1 : Number(value);
		this.rowsDetailModal[index].amountHaber =
			value < 0 ? Number(value) * -1 : Number(value);
	}
}
function changeAccount(item) {
	const { value, index } = item;
	this.rowsDetailModal[index].accountingAccount = value;
	this.rowsDetailModal[index].accountingAccountId = value.id;
	this.rowsDetailModal[index].account = value.code;
}

function changeCostCenter(item) {
	const { value, index } = item;
	this.rowsDetailModal[index].costCenter = value;
	this.rowsDetailModal[index].costCenterId = value.id;
	const firstDigit = this.rowsDetailModal[index].accountingAccount.account.charAt(0);
	this.flagValidNumberAccount = ((Number(firstDigit) >= 4 && Number(firstDigit) <= 8)
		&& this.rowsDetailModal[index].costCenterId === null);
}

async function saveSeat(row, index) {
	try {
		this.rowsDetailModal[index].edit = false;
		const body = {
			account: row.accountingAccount.code,
			accountingAccountId: row.accountingAccount.id,
			amount: row.amount,
			concept: row.concept,
			costCenterId: row.costCenterId,
			reference: row.reference,
		};
		await this.$http.patch(
			`accounting-seat-details/${row.accountingSeatId}/${row.id}`,
			body,
		);
		this.loadAccountingDetail();
		this.showNotification('Asiento contable actualizado correctamente');
	} catch (error) {
		this.showGenericError();
	}
}
function deleteSeat(row, index) {
	this.indexRowDetail = index;
	this.modalDeleteSeat = true;
	this.titleDialogDelete = 'Eliminar Detalle De Asiento';
	this.rowForDelete = { ...row };
}
function closeModalDeleteSeat() {
	this.modalDeleteSeat = false;
	this.titleDialogDelete = '';
	this.rowForDelete = {};
}

function closeModalWaitSeat() {
	this.modalWaitSeats = false;
}
async function eliminateSeat() {
	// try {
	// 	await this.$http.delete(`accounting-seat-details/${this.rowForDelete.id}`);
	// 	this.loadAccountingDetail();
	// 	this.showNotification('El detalle de asiento ha sido eliminado correctamente.');
	// } catch (err) {
	// 	if (err.status === 500) {
	// 		this.showGenericError();
	// 	}
	// } finally {
	// 	this.loading = false;
	// 	this.dialogDetailAccounting = false;
	// 	this.closeModalDeleteSeat();
	// }
	this.rowsDetailModal.splice(this.indexRowDetail, 1);
	this.closeModalDeleteSeat();
}

function setValue(type, row) {
	let value;
	if (type === 'registro') {
		const strValue = row.amount.toString() || row.totalDebe.toString();
		value = this.refactorizeNumber(strValue);
	} else if (type === 'totalDebe') {
		const strValue = row.totalDebe.toString();
		value = this.refactorizeNumber(strValue);
	} else if (type === 'totalHaber') {
		const strValue = row.totalHaber.toString();
		value = this.refactorizeNumber(strValue);
	}
	return value;
}

function refactorizeNumber(value) {
	const decimalIndex = value.indexOf('.');
	if (decimalIndex === -1) {
		return `${value}.00`;
	}
	const integerPart = value.slice(0, decimalIndex);
	const decimalPart = value.slice(decimalIndex + 1, decimalIndex + 3);
	return `${integerPart}.${decimalPart.padEnd(2, '0')}`;
}

function validateSomeForceInsertCenterCost() {
	let valid = false;
	if (this.rowsDetailModal.length > 0) {
		if (this.settings.autoCenterCost) {
			valid = this.rowsDetailModal.some(d => /^[45678]/.test(d.accountingAccount.account) && d.costCenterId === null);
			if (valid) {
				this.showNotification('Hay cuentas con 4, 5, 6, 7, 8 sin centro de costo asignado');
			}
		}
		return valid;
	}
	return valid;
}

async function saveAllDetailsEdits() {
	this.isLoading = true;
	const body = this.formatData(this.rowsDetailModal);
	try {
		const { data: response } = await this.$http.patch(`accounting-seat-update-daily/${this.dataSeat.id}`, body);
		this.rowsDetailModal = response.details;
		this.rowsDetailModal = this.rowsDetailModal.map((ds) => {
			const newDs = { ...ds };
			newDs.accountingAccount = this.accounts.find(a => a.id === ds.accountingAccountId);
			newDs.costCenterId = ds.costCenterId ? ds.costCenterId : null;
			newDs.costCenter = this.costCenters.find(cc => cc.id === ds.costCenterId);
			newDs.amount = ds.amountDebe > 0 ? ds.amountDebe : (ds.amountHaber * -1);
			return newDs;
		});
		this.showNotification('Detalles actualizados Correctamente');
		// this.closeDialog();
		this.loadCont();
	} catch (error) {
		this.showGenericError();
	} finally {
		this.dialogDetailAccounting = false;
		this.openDetailSeat = false;
		this.isLoading = false;
		this.flagValidCostCenter = false;
		this.flagValidNumberAccount = false;
	}
}

function formatData(value) {
	const totalDebe = value.reduce((sum, item) => sum + item.amountDebe, 0);
	const totalHaber = value.reduce((sum, item) => sum + item.amountHaber, 0);
	const details = value.map((d) => {
		const newD = {};
		newD.id = d.id ? d.id : null;
		newD.type = d.type;
		newD.account = d.account || null;
		newD.concept = d.concept;
		newD.reference = d.reference;
		newD.amountDebe = Number(d.amountDebe);
		newD.amountHaber = Number(d.amountHaber);
		newD.costCenterId = d.costCenterId ? d.costCenterId : null;
		newD.accountingAccountId = d.accountingAccountId;
		return newD;
	});
	const newData = {
		totalDebe,
		totalHaber,
		details,
	};
	return newData;
}

function validSquareAmounts() {
	let valid = false;
	if (this.rowsDetailModal.length > 0) {
		const debe = this.rowsDetailModal.reduce((sum, item) => sum + item.amountDebe, 0);
		const haber = this.rowsDetailModal.reduce((sum, item) => sum + item.amountHaber, 0);
		valid = debe > haber || debe < haber;
	}
	return valid;
}

function onAddDetail() {
	this.openDetailSeat = true;
	this.modelDetail.reference = this.rowsDetailModal.length > 0 ?
		this.rowsDetailModal[0].reference : null;
	this.modelDetail.concept = this.rowsDetailModal.length > 0 ?
		this.rowsDetailModal[0].concept : null;
}

function setData(value) {
	this.accountingAccount = { ...value };
	this.modelDetail.account = value.code;
	this.modelDetail.accountingAccountId = value.id;
}

function setModelData({ model, value }) {
	if (model === 'date' || model === 'gloss') {
		this.model[model] = value;
	} else {
		this.modelDetail[model] = value;
	}
}
function setCostCenter(value) {
	this.costCenter = { ...value };
	this.modelDetail.costCenterId = value.id;
}
function typeDetail() {
	return this.modelDetail.amount < 0 ? 'HABER' : 'DEBE';
}
function validFields() {
	return !this.modelDetail.account || !this.modelDetail.accountingAccountId
	|| !this.modelDetail.amount	|| !this.modelDetail.concept
	|| !this.modelDetail.reference;
}
function validInsertCostCenter() {
	let valid = false;
	if (this.settings.autoCenterCost) {
		const firstDigit = this.modelDetail.account.charAt(0);
		if ((Number(firstDigit) >= 4 && Number(firstDigit <= 8)) && !this.modelDetail.costCenterId) {
			valid = true;
		}
	}
	return valid;
}
async function saveNewDetailSeat() {
	const amount = Number(this.modelDetail.amount);
	const type = amount > 0 ? 'Debe' : 'Haber';
	this.modelDetail.type = amount > 0 ? 1 : 2;
	this.modelDetail.status = 1;
	this.modelDetail[`amount${type}`] = type === 'Debe' ? amount : (amount * -1);
	const otherType = type === 'Debe' ? 'Haber' : 'Debe';
	this.modelDetail[`amount${otherType}`] = 0;
	this.rowsDetailModal.push({
		...this.modelDetail,
		accountingAccount: this.accountingAccount,
		costCenter: this.costCenter,
		flagEdit: 1,
	});
	this.openDetailSeat = false;
	this.clearModels();
}
function clearModels() {
	this.modelDetail = {
		accountingAccountId: null,
		account: null,
		concept: '',
		reference: '',
		costCenterId: null,
		amount: 0,
	};
}

function validCostCenter() {
	let valid = false;
	if (this.modelDetail.account !== null) {
		const firstDigit = this.modelDetail.account.charAt(0);
		valid = (Number(firstDigit) < 4 && Number(firstDigit) > 8);
	}
	if (valid) {
		this.setCostCenter({});
	}
	return valid;
}

function validateDateRow(row) {
	console.log('row::: ', row);
	if (row.moduleId) {
		if (row.moduleId === 3 || row.moduleId === 4) {
			if (!row.flagFacWithDocStatus) {
				const paymentDate = row.additionalInformation &&
					row.additionalInformation.paymentDate ?
					row.additionalInformation.paymentDate : row.paymentDate;
				return format(paymentDate, 'DD-MM-YYYY');
			}
			return format(row.createdAt, 'DD-MM-YYYY');
		}
		if (row.moduleId === 8 || row.moduleId === 9) {
			console.log('row.moduleId::: ', row.moduleId);
			return row.paymentDate && row.paymentDate
				? `${format(row.paymentDate, 'DD-MM-YYYY')} / ${format(row.createdAt, 'DD-MM-YYYY')}` : format(row.createdAt, 'DD-MM-YYYY');
		}
		return format(row.createdAt || row.dateEnd, 'DD-MM-YYYY');
	} else if (row.moduleCode === 'BANCO' || row.moduleCode === 'CAJA') {
		return row.paymentDate && row.paymentDate
			? `${format(row.paymentDate, 'DD-MM-YYYY')} / ${format(row.createdAt, 'DD-MM-YYYY')}` : format(row.createdAt, 'DD-MM-YYYY');
	}
	return format(row.createdAt || row.dateEnd, 'DD-MM-YYYY');
}

function data() {
	return {
		deleteTooltip: 'Eliminar Asiento',
		currentPage: 1,
		flagNoConfirm: false,
		flagStatusAccounting: false,
		currentPageDetail: 1,
		e13: 1,
		flagWait: false,
		accounts: [],
		costCenters: [],
		rowsIds: [],
		stepStatus: {},
		rowIdsModules: [],
		checkAllAccounting: false,
		checkAll: false,
		columns: [
			{
				id: 1,
				name: 'F. de Crea. / Pago',
				tooltip: 'Fecha de Creación / Pago',
				value: 'account',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 2,
				name: 'Numero de documento: ',
				value: 'name',
				checked: true,
				visible: true,
			},
			{ id: 3, name: 'Referencia: ', checked: true, visible: true, movil: true },
			{ id: 4, name: 'Módulo: ', checked: true, visible: true, movil: true },
			{ id: 5, name: 'Monto', checked: true, visible: true, movil: true },
		],
		columnsSeat: [
			{
				id: 1,
				name: 'Asiento',
				value: 'code',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 2,
				name: 'Módulo',
				value: 'module',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 3,
				name: 'Descripción',
				value: 'description',
				checked: true,
				visible: true,
			},
			{
				id: 4,
				name: 'Fecha',
				value: 'date',
				checked: true,
				visible: true,
				movil: true,
			},
			{ id: 5, name: 'Estado', checked: true, visible: true, movil: true },
			{ id: 6, name: 'Debe', checked: true, visible: true, movil: true },
			{ id: 7, name: 'Haber', checked: true, visible: true, movil: true },
			{ id: 8, name: 'Acción', checked: true, visible: true, movil: true },
		],
		columnsDetail: [
			{
				id: 1,
				name: 'Cód. Cta.',
				value: 'code',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 2,
				name: 'Cuenta Cta.',
				value: 'code',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 3,
				name: 'Referencia',
				value: 'code',
				checked: true,
				visible: true,
			},
			{
				id: 4,
				name: 'Concepto de mov',
				value: 'code',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 5,
				name: 'Tipo',
				value: 'code',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 6,
				name: 'Importe',
				value: 'code',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 7,
				name: 'Centro de costo',
				value: 'code',
				checked: true,
				visible: true,
			},
			{
				id: 8,
				name: 'acciones',
				value: 'actions',
				checked: true,
				visible: true,
			},
		],
		dialogLoading: false,
		itemsTotalQuantity: null,
		itemsTotalQuantityDetails: null,
		dialogDetailAccounting: false,
		dialogAction: false,
		dialogWait: false,
		flagDate: false,
		dataSelectedAccounting: [],
		dataSelected: [],
		dialogDeleteAccounting: false,
		listAccounting: true,
		lastPage: 0,
		lastPageDetails: 0,
		modules: [],
		model: {
			limit: 20,
			search: null,
			moduleId: null,
			stateId: 'pending',
			startDate: null,
			endDate: null,
			onSearch: null,
			status: null,
			accountingSeat: null,
			square: 1,
		},
		mobile: false,
		flagCancel: true,
		nameAccouting: null,
		cancelModal: false,
		showDetailAccounting: false,
		rowsDetails: [],
		rowsDetailModal: [],
		rows: [],
		rowsSeat: [],
		showAccouting: false,
		openMobile: false,
		titleDialogDelete: '',
		rowForDelete: {},
		flagStateRecord: true,
		titleModule: '',
		titleModuleSeat: '',
		valuesShow: {},
		newModules: [],
		modulesFilter: [],
		status: [
			// { id: 2, name: 'Anulados' },
			{ id: 3, name: 'Pendientes' },
			{ id: 1, name: 'Contabilizados' },
		],
		statusRecords: [
			{ id: 0, name: 'Sin asiento' },
			// { id: 1, name: 'Con asiento' },
		],
		typesModule: [
			{ id: 1, name: 'Cuadrados' },
			{ id: 2, name: 'No Cuadrados' },
		],
		typesDate: [
			{ id: 1, name: 'Hoy' },
			{ id: 2, name: 'Ayer' },
			{ id: 3, name: 'Ultima Semana' },
			{ id: 4, name: 'Mes Actual' },
			{ id: 5, name: 'Año Actual' },
			{ id: 6, name: 'Rangos de Fechas' },
		],
		subsidiaryId: null,
		loading: false,
		modalWaitSeats: false,
		progress: 0, // Progreso actual (0-100)
		modalDeleteSeat: false,
		seatRowforDelete: {},
		settings: {},
		squareAmounts: false,
		isLoading: false,
		flagValidNumberAccount: false,
		flagValidCostCenter: false,
		flagbtnCloseSeatModal: false,
		dataSeat: {},
		indexRowDetail: null,
		openDetailSeat: false,
		modelDetail: {
			accountingAccountId: null,
			account: null,
			concept: '',
			reference: '',
			costCenterId: null,
			amount: 0,
		},
		accountingAccount: {},
		costCenter: {},
		flagNewModules: false,
	};
}

export default {
	name: 'page-batch-accounting',
	created,
	data,
	destroyed,
	components: {
		actionBar,
		appTooltipButton,
		appDateSelect,
		dateComponent,
		BaseSelect,
		autocompleteComponent,
		appInputText,
		closeIcon,
	},
	computed: {
		disabledConfirm,
		valuesDisabled,
		...mapGetters('subsidiary', ['currentSubsidiary']),
		verifySubsidiary,
		validateSomeForceInsertCenterCost,
		typeDetail,
		validFields,
		validInsertCostCenter,
		validCostCenter,
		validSquareAmounts,
	},
	methods: {
		changePage,
		setTypes,
		getDataDate,
		onPage,
		closeDialog,
		clearAccouting,
		setId,
		loadAccounts,
		closeDialogAction,
		onDeleteSeat,
		onDeleteSeatMultiple,
		closeDialogAccouting,
		closeMobile,
		getDate,
		getType,
		loadAccounting,
		loadCont,
		loadModules,
		loadAccountingDetail,
		verifyNewModules,
		statusColor,
		statusColorModules,
		statusNameModules,
		setModule,
		setStatus,
		setStatusRecords,
		openDialogDelete,
		openDetail,
		onSearch,
		rowIsSelected,
		rowIsSelectedAccounting,
		runAction,
		saveAccouting,
		statusName,
		selectedAll,
		selectedAllSeat,
		postRecord,
		goToEditAccouting,
		reziseMobile,
		openMobileAccouting,
		changeAccount,
		editSeats,
		saveSeat,
		eliminateSeat,
		deleteSeat,
		closeModalDeleteSeat,
		closeModalWaitSeat,
		changeAmountSeat,
		loadCostCenter,
		changeCostCenter,
		setValue,
		refactorizeNumber,
		saveAllDetailsEdits,
		formatData,
		onAddDetail,
		setData,
		setModelData,
		setCostCenter,
		saveNewDetailSeat,
		clearModels,
		validateDateRow,
	},
};
</script>

<style lang="scss" scoped>
.custom-step .v-icon {
  color: white !important; /* Fuerza el color blanco */
}

.tooltip-container {
	position: relative;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	color: white;
	padding: 10px;
	border-radius: 4px;
	width: fit-content;
	height: 20px;
	min-width: 60px; /* Evita que se haga demasiado pequeño */
	font-size: 9px;
	font-family: font(AvenirBold);
}

td {
	text-align: center;
	vertical-align: middle;
}

.btn-accounting {
	border-radius: 5px !important;
	box-shadow: none !important;
	color: white !important;
	font-family: map-get($fonts, AvenirRegular) !important;
	font-size: 12px !important;
	font-weight: 600;
	text-transform: capitalize !important;
	width: 80px;

	@media (max-width: 1024px) {
		width: 100%;
	}
}
.btnSaveAccounting {
	color: white !important;
}
#column-6 {
	span {
		color: red !important;
	}
}
.titleNumberSeat {
	color: #02979b !important;
	font-family: 'Avenir Regular', Arial, sans-serif;
	font-weight: bold;
}
.loading-search {
	color: white !important;
	font-family: map-get($fonts, AvenirDemi) !important;
	font-size: 14px !important;
	text-align: center;
}
.btn-modal {
	border-radius: 30px;
	color: map-get($colors, white);
	height: 30px;
	padding: 0px 20px;
	width: 93px;
}
.content-dialog {
	box-shadow: none !important;
}

.blue-debe {
	color: #006edb;
	font-family: map-get($fonts, AvenirBold);
	padding: 0 5px;
}
.captionDate {
	font-size: 10px;
	text-align: center;
	font-family: 'AvenirRegular';
}
.red-haber {
	color: #ff0000;
	font-family: map-get($fonts, AvenirBold);
	text-align: end;
	padding: 0 5px;
}

.btn {
	border-radius: 30px;
	color: white;
	height: 30px;
	padding: 0 10px;
	width: 90px;
}

.agree {
	background-color: color(secondary);
	margin-left: 10px;
}

.cancel {
	background-color: color(error);
	margin-right: 10px;
}
.cancelSeat {
	background-color: color(error);
}
.save {
	background-color: color(secondary);
}

.show-mobile {
	@media (max-width: 890px) {
		padding: 8px !important;
	}
}

.row-mobile {
	@media (min-width: 1024px) {
		padding: 0 24px;
	}
}

.gloss {
	@media (max-width: 768px) {
		background-color: #eceff1;
		display: grid;
		grid-column: 1/8;
		grid-row: 2;
		white-space: nowrap;
	}
}

.reference {
	@media (max-width: 768px) {
		background-color: #eceff1;
		display: grid;
		grid-column: 1/7;
		grid-row: 2;
		white-space: nowrap;
	}
}

.entity {
	@media (max-width: 768px) {
		background-color: #eceff1;
		display: grid;
		grid-column: 1/5;
		grid-row: 2;
		white-space: nowrap;
	}
}

.desktop {
	@media (min-width: 768px) {
		display: none;
	}
}

.mobile {
	@media (max-width: 768px) {
		display: none;
	}
}

.content-acc {
	@media (max-width: 768px) {
		left: -100%;
		position: absolute;
		transition: all 0.2s ease-in-out 0s;
		z-index: 2;

		&.open {
			left: 0;
			width: 100%;
		}
	}
}

.horizontal-buttons {
  overflow-x: auto; /* Permite el desplazamiento horizontal si los elementos no caben */
  white-space: nowrap; /* Evita que los elementos se envuelvan */
}

.horizontal-buttons .v-flex {
  display: inline-block; /* Muestra los elementos en línea */
  margin-right: 8px; /* Espacio entre los elementos */
}

.horizontal-buttons .v-flex:last-child {
  margin-right: 0; /* Elimina el margen del último elemento */
}

.loading-icon {
	display: inline-flex;
	align-items: center;
}

// .dialog-container {
// 	background-color: #f9f9f9;
// 	border: 1px solid #ccc;
// 	border-radius: 8px;
// 	box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
// 	display: none;
// 	flex-direction: column;
// 	align-items: center;
// }

.spinner {
	border: 4px solid rgba(0, 0, 0, 0.1);
	border-top: 4px solid #3d989b;
	border-radius: 100%;
	width: 60px;
	height: 40px;
	margin: 20px;
	animation: spin 1s linear infinite;
}

@keyframes spin {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}

.titleWait {
	font-family: 'Avenir Regular', Arial, sans-serif;
	font-size: 20px;
	font-weight: bold;
	display: inline-block;
	margin: 0;
}
.text-card {
	border-radius: 10px;
	background-color: #e6e2e2;
}

.btn-edit-detail {
	background-color: color(secondary);
	border-radius: 10px;
	color: color(white);
	font-family: font(AvenirBold);
	font-size: size(small11);
	padding: 2px 4px 0px;
}
.wrapper-text {
	left: 57px;
	position: absolute;
	top: 10px;
}
.border-radius {
	border-radius: 50%;
	height: 23px;
	width: 23px;
}
</style>



// WEBPACK FOOTER //
// src/pages/accounting-periods/page-batch-accounting.vue